var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLengehRail41Right2Right3Right4Fix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83.9 33.3",
    style: {
      enableBackground: "new 0 0 83.9 33.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,1.5h20.2v30.3H1V1.5 M0,0.5v32.3h22.2V0.5H0L0,0.5z M6,6.5h10.2v20.3H6V6.5 M5,5.5v22.3h12.2V5.5H5L5,5.5z M22,1.5h19.7 v30.3H22l-1,1h21.7V0.5H21l0,0L22,1.5 M22.5,6.5h14.2v20.3H21.5v1h16.2V5.5H21.5l0,0v1 M63.2,1.5h19.7v30.3H63.2l-1,1h21.7V0.5H62.2 l0,0L63.2,1.5 M63.7,5.2h15.2V28H62.7v1h17.2V4.2H62.7v1.5V5.2 M7,17.2h5.5v-1H7V17.2z M15.3,16.6L12,13.3v6.6L15.3,16.6z  M25.3,17.2h5.5v-1h-5.5V17.2z M33.6,16.6l-3.3-3.3v6.6L33.6,16.6z M42.6,1.5h19.7v30.3H42.6l-1,1h21.7V0.5H41.6l0,0L42.6,1.5  M43.1,6.5h14.2v20.3H42.1v1h16.2V5.5H42.1l0,0v1 M45.9,17.2h5.5v-1h-5.5V17.2z M54.2,16.6l-3.3-3.3v6.6L54.2,16.6z M75.1,16.2h-7.7 v1h7.7V16.2z M71.8,12.8h-1v7.7h1V12.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengehRail41Right2Right3Right4Fix);
export default __webpack_public_path__ + "static/media/LENGEH_RAIL_4_1RIGHT_2RIGHT_3RIGHT_4FIX.114908b65c0a4d5070a5d26dfda7600b.svg";
export { ForwardRef as ReactComponent };